import { MAP_ZOOM, TILE_HEIGHT, TILE_WIDTH } from '@/shared/constants';
import { screenToWorld } from '@/modules/game-renderer/coordinates';

/** Viewport half-extents in screen space (matches drawNPCs, scaled by multiplier). */
export function viewportHalfExtents(
  screenWidth: number,
  screenHeight: number,
  multiplier = 1.5,
  zoom = MAP_ZOOM,
): { halfW: number; halfH: number } {
  const scale = multiplier;
  return {
    halfW: (screenWidth / (2 * zoom) + TILE_WIDTH * 3) * scale,
    halfH: (screenHeight / (2 * zoom) + TILE_HEIGHT * 3) * scale,
  };
}

/** World-space radius matching 1.5× viewport (for server awareness queries). */
export function viewportAwarenessRadiusWorld(
  screenWidth: number,
  screenHeight: number,
  multiplier = 1.5,
  zoom = MAP_ZOOM,
): number {
  const { halfW, halfH } = viewportHalfExtents(screenWidth, screenHeight, multiplier, zoom);
  const corner = screenToWorld(halfW, halfH);
  const origin = screenToWorld(0, 0);
  const dx = corner.x - origin.x;
  const dy = corner.y - origin.y;
  return Math.sqrt(dx * dx + dy * dy);
}

/** True when a world point is within the camera-centered viewport bounds. */
export function isWorldPointInViewport(
  worldX: number,
  worldY: number,
  camX: number,
  camY: number,
  screenWidth: number,
  screenHeight: number,
  multiplier = 1.5,
  zoom = MAP_ZOOM,
): boolean {
  const { halfW, halfH } = viewportHalfExtents(screenWidth, screenHeight, multiplier, zoom);
  const isoX = (worldX - worldY) * (TILE_WIDTH / 2);
  const isoY = (worldX + worldY) * (TILE_HEIGHT / 2);
  return (
    Math.abs(isoX - camX) <= halfW &&
    Math.abs(isoY - camY) <= halfH
  );
}
